export default __webpack_public_path__ + "left_control.png";